<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			video: ISbStoryData[];
			label: string;
			description: string;
			show_overlay: boolean;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="relative h-full">
	{#if content.video.length > 0}
		<Blok content={content.video[0]} />
	{/if}

	{#if content.show_overlay}
		<div class="absolute inset-0 bg-brown-2/20"></div>
	{/if}
	{#if content.label || content.description}
		<div
			class="absolute inset-x-8 inset-y-0 flex flex-col items-center justify-center text-center text-stone-5 lg:inset-x-12 xl:inset-x-20"
		>
			<p class="text-[32px]/[110%] font-semibold tracking-[-.56px] lg:text-[56px]">
				{content.label}
			</p>
			<p class="mt-4 text-[16px]/[140%] lg:text-[24px]">{content.description}</p>
		</div>
	{/if}
</div>
